import type { TOC } from '@ember/component/template-only';

/**
 * Reflows by available container width using auto-fit and a preset minimum card width. Presets also
 * set gaps; narrow suits metrics, medium suits feature cards.
 */
export type CardGridDensity = 'narrow' | 'medium' | 'wide';

interface CardGridSignature {
  Args: {
    /** Density preset — sets the auto-fit min column width and gap. Default: 'medium'. */
    density?: CardGridDensity;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const CardGrid: TOC<CardGridSignature> = <template>
  <div
    data-test-card-grid
    data-card-grid
    data-card-grid-density={{if @density @density "medium"}}
    class="app-card-grid app-card-grid--{{if @density @density 'medium'}}"
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export default CardGrid;

export type { CardGridSignature };
